import { Icon } from "@chakra-ui/react";
import { FaHourglassHalf } from "react-icons/fa";
export const LoadingPage = () => {
    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className=" flex w-full h-fit items-center flex-col">
                <Icon fontSize="60px" color={'black'}>
                    <FaHourglassHalf />
                </Icon>
                <p className="font-semibold text-xl text-justify mt-4">
                    ...Cargando datos de usuario
                </p>
            </div>
        </div>
    );
};